import "./i18n";
import "./App.css";
import "./index.css";
import 'leaflet/dist/leaflet.css';
import { useTranslation } from "react-i18next";
import { BrowserRouter, Router } from "react-router-dom";
import { AuthProvider } from "./Helpers/Auth";
import history from "./Helpers/history";
import Routes from "./routes";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter history={history}>
        <Routes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
